import RegionPopup from './RegionPopup';

export default RegionPopup;



// WEBPACK FOOTER //
// ./src/components/Header/Region/RegionPopup/index.js